import { SaleTransactionType } from 'api-hooks/refund/refund';
import HOCWatchValue from 'components/common/hoc-watch-value';
import { Input } from 'components/elements';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

export default function SaleRefundField() {
  const { t } = useTranslation();
  const { setValue } = useFormContext<any>();

  const values = HOCWatchValue({
    keys: [
      'transactionSaleType',
      'flightSales',
      // 'flightPurchases',
      'hotelSales',
      // 'hotelPurchases',
      'activitySales',
      // 'activityPurchases',
      'cruiseSales',
      // 'cruisePurchases',
      'documentSales',
      // 'documentPurchases',
      'productSales',
      'tourSales',
    ],
  });

  React.useEffect(() => {
    if (values.transactionSaleType === SaleTransactionType.FLIGHT) {
      const guestSaleAmount = values.flightSales
        .filter((fs) => fs.flightSaleGuests.some((fst) => fst.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const parentTemp = parentCurr.flightSaleGuests
            .filter((fsg) => fsg.isSelected)
            .reduce((prev, curr) => {
              return prev + curr.refundPrice;
            }, 0);
          return parentPrev + parentTemp;
        }, 0);

      const addOnsSaleAmount = values.flightSales
        .filter((fs) => fs.flightSaleAddOns.some((fst) => fst.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const parentTemp = parentCurr.flightSaleAddOns
            .filter((fsg) => fsg.isSelected)
            .reduce((prev, curr) => {
              return prev + curr.refundPrice;
            }, 0);
          return parentPrev + parentTemp;
        }, 0);

      setValue('releaseSale.amount', guestSaleAmount + addOnsSaleAmount);
    } else if (values.transactionSaleType === SaleTransactionType.HOTEL) {
      const amount = values.hotelSales
        .filter((hs) => hs.isSelected)
        .reduce((parentPrev, parentCurr) => {
          const roomAmount = parentCurr.hotelSaleHotels.reduce(
            (prev, curr) => prev + curr.refundPrice,
            0,
          );
          const addonsAmount = parentCurr.hotelSaleAddOns
            .filter((hsao) => hsao.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);

          return parentPrev + roomAmount + addonsAmount;
        }, 0);
      setValue('releaseSale.amount', amount);
    } else if (values.transactionSaleType === SaleTransactionType.CRUISE) {
      const guestAmount = values.cruiseSales
        .filter((cs) => cs.cruiseSaleDetails.some((cst) => cst.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const amount = parentCurr.cruiseSaleDetails
            .filter((csg) => csg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + amount;
        }, 0);
      const addonsAmount = values.cruiseSales
        .filter((cs) => cs.cruiseSaleAddOns.some((cst) => cst.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const amount = parentCurr.cruiseSaleAddOns
            .filter((csg) => csg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + amount;
        }, 0);
      setValue('releaseSale.amount', guestAmount + addonsAmount);
    } else if (values.transactionSaleType === SaleTransactionType.ACTIVITY) {
      const guestAmount = values.activitySales
        .filter((as) => as.activitySaleGuests.some((ast) => ast.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const temp = parentCurr.activitySaleGuests
            .filter((asg) => asg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + temp;
        }, 0);

      const addonsAmount = values.activitySales
        .filter((as) => as.activitySaleAddOns.some((ast) => ast.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const temp = parentCurr.activitySaleAddOns
            .filter((asg) => asg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + temp;
        }, 0);
      setValue('releaseSale.amount', guestAmount + addonsAmount);
    } else if (values.transactionSaleType === SaleTransactionType.DOCUMENT) {
      const guestAmount = values.documentSales
        .filter((as) => as.documentSaleGuests.some((ast) => ast.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const temp = parentCurr.documentSaleGuests
            .filter((asg) => asg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + temp;
        }, 0);

      const addonsAmount = values.documentSales
        .filter((as) => as.documentSaleAddOns.some((ast) => ast.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const temp = parentCurr.documentSaleAddOns
            .filter((asg) => asg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + temp;
        }, 0);
      setValue('releaseSale.amount', guestAmount + addonsAmount);
    } else if (values.transactionSaleType === SaleTransactionType.PRODUCT) {
      const productAmount = values.productSales
        .filter((ps) => ps.isSelected)
        .reduce((total, { refundPrice }) => total + refundPrice, 0);

      setValue('releaseSale.amount', productAmount);
    } else if (values.transactionSaleType === SaleTransactionType.TOUR) {
      const guestAmount = values.tourSales
        .filter((as) => as.tourSaleGuests.some((ast) => ast.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const temp = parentCurr.tourSaleGuests
            .filter((asg) => asg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + temp;
        }, 0);
      const addonsAmount = values.tourSales
        .filter((as) => as.tourSaleAddOns.some((ast) => ast.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const temp = parentCurr.tourSaleAddOns
            .filter((asg) => asg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + temp;
        }, 0);

      setValue('releaseSale.amount', guestAmount + addonsAmount);
    }
  }, [setValue, values]);

  return (
    <Input
      type="number"
      name="releaseSale.amount"
      label={t('refund:refund_amount')}
      placeholder={t('refund:refund_amount')}
      disabled
    />
  );
}
